module.exports = __webpack_public_path__ + "static/img/4.32b85fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/4.png
// module id = ModO
// module chunks = 0